@if(setting.options.length > 0) {
<section class="row p-2 pt-1">
  @if (singleColumn ? false : showDragDropSection()) {
  <mat-form-field class="col-md-auto col-xs-12 pb-3">
    <mat-label>Search</mat-label>
    <input
      matInput
      [(ngModel)]="searchText"
      (ngModelChange)="filterList()"
      (keydown.enter)="selectOption()"
      [acsFocus]="jumpFocus === 'searchText'"
      autocomplete="off"
    />
    <button mat-icon-button matIconSuffix (click)="clearInput()" color="warn">
      <mat-icon class="fa fa-close"></mat-icon>
    </button>
  </mat-form-field>
  }

  <span class="align-self-center col col-xs-12">
    <div class="mb-1 d-flex flex-row align-items-center justify-content-between">
      @if (setting.type === 'multiCheckSelect') { @if (systemTypeGroup && !inModal) {
      <mat-form-field class="me-2 pl-0 mb-3 col-7">
        <mat-label>{{ systemTypeGroup.name }}</mat-label>
        <mat-select
          [(ngModel)]="selectedSystemTypeGroup"
          (selectionChange)="onSelectionChange($event)"
        >
          @for (option of systemTypeGroup.options; track option) {
          <mat-option [value]="option.id">
            {{ option.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      } }

      <div
        class="d-flex w-100"
        [ngClass]="
          showDragDropSection()
            ? 'justify-content-start'
            : systemTypeGroup
            ? 'justify-content-around'
            : 'justify-content-center'
        "
      >
        @if (setting.showAllOption) {
        <button mat-raised-button class="md-button m-2" (click)="selectAll()">All</button>
        } @if (setting.showNoneOption) {
        <button mat-raised-button class="md-button m-2" (click)="unselectAll()">None</button>
        } @if (showAddButton) {
        <button mat-raised-button class="md-button m-2" (click)="addOption()">Add</button>
        } @if (setting.type === 'multiCheck') { @for (group of setting.optionGroupings; track
        getIdentifierForIterableItem($index, group)) { @if (group.id !== 'systemType' || (group.id
        === 'systemType' && group.options.length > 1)) { @for (option of group.options; track
        getIdentifierForIterableItem($index, option)) { @if (group.id) {
        <button
          mat-raised-button
          class="md-button m-2"
          (click)="setting.selectGroup(group.id, option.id)"
        >
          {{ option.name }}
        </button>
        } } } } }
      </div>
    </div>

    @if (singleColumn) {
    <div class="row mb-3">
      <div class="example-container col">
        <div class="example-list" style="max-height: 400px; overflow: auto">
          @for (item of setting.options; track getIdentifierForIterableItem($index, item)) { @if
          (item.visible || isTruckType) {
          <div class="example-box" style="cursor: default">
            <mat-checkbox [(ngModel)]="item.selected" color="primary">
              {{ item.name || item.description }}
            </mat-checkbox>
          </div>
          } }
        </div>
      </div>
    </div>
    }
  </span>
</section>

@if (singleColumn ? false : !showDragDropSection()) {
<mat-list role="list" class="d-flex row">
  @for (option of setting.options; track getIdentifierForIterableItem($index, option)) {
  <div class="col-4">
    <mat-list-item role="listitem">
      <mat-checkbox color="primary" [(ngModel)]="option.selected">
        <p>{{ option.name }}</p>
      </mat-checkbox>
    </mat-list-item>
  </div>
  }
</mat-list>
} @if (singleColumn ? false : showDragDropSection()) {
<div class="row mb-3" [ngStyle]="{ height: showDragDrop ? '50vh' : null }">
  <div class="example-container col">
    <h4 class="sub-header">Available</h4>
    <div
      cdkDropList
      #availableList="cdkDropList"
      [cdkDropListData]="available"
      [cdkDropListConnectedTo]="[selectedList]"
      class="example-list"
      style="max-height: 400px; overflow: auto"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of available; track getIdentifierForIterableItem($index, item)) {
      <div class="example-box" cdkDrag>
        <mat-checkbox [(ngModel)]="item.selected" (ngModelChange)="filterList()" color="primary">
          {{ item.name }}
        </mat-checkbox>
      </div>
      }
    </div>
  </div>
  <div class="example-container col">
    <h4 class="sub-header">Selected</h4>
    <div
      cdkDropList
      #selectedList="cdkDropList"
      [cdkDropListData]="selected"
      [cdkDropListConnectedTo]="[availableList]"
      class="example-list"
      style="max-height: 400px; overflow: auto"
      (cdkDropListDropped)="drop($event)"
    >
      @for (item of selected; track getIdentifierForIterableItem($index, item)) {
      <div
        class="example-box"
        cdkDrag
        [cdkDragDisabled]="selected.length === 1 && !setting.allowEmpty"
      >
        <mat-checkbox
          [(ngModel)]="item.selected"
          [disabled]="selected.length === 1 && !setting.allowEmpty"
          color="primary"
          (ngModelChange)="filterList()"
          >{{ item.name }}
        </mat-checkbox>
      </div>
      }
    </div>
  </div>
</div>
} } @else {
<span>No items available to choose from</span>
}

<!--     <span *ngFor="let group of setting.optionGroupings; trackBy: getIdentifierForIterableItem"> -->
<!--       <button -->
<!--         mat-raised-button -->
<!--         class="md-button m-2" -->
<!--         aria-label="" -->
<!--         *ngFor="let option of group.options; trackBy: getIdentifierForIterableItem" -->
<!--         (click)="setting.selectGroup(group.id, option.id)" -->
<!--       > -->
<!--         {{ option.name }} -->
<!--       </button> -->
<!--     </span> -->
